import React from 'react'
import SharedNavbar from './SharedNavbar'

const ContactUs = () => {
  return (
    <div>
      <SharedNavbar />
    </div>
  )
}

export default ContactUs